import { requireDashboardOrigin } from "@api/auth/dashboardOriginGuard"
import { serverRouteConfig } from "@lib/serverRouteConfig"
import { createFileRoute } from "@tanstack/react-router"
import * as z from "zod"

const callbackInputSchema = z.object({
  code: z.string().min(1),
  codeVerifier: z.string().min(1),
})

export const Route = createFileRoute("/api/dashboard/auth/callback")(
  serverRouteConfig({
    server: {
      handlers: {
        POST: async ({ request }) => {
          const originError = requireDashboardOrigin(request)
          if (originError) return originError

          try {
            const input = callbackInputSchema.parse(await request.json())
            const { completeDashboardAuthorizationCode } = await import("@api/auth/dashboardAuthApi")
            const result = await completeDashboardAuthorizationCode(input)
            return Response.json(result.payload, { headers: { "Set-Cookie": result.setCookie } })
          } catch (error) {
            return Response.json(
              { error: error instanceof Error ? error.message : "Could not complete sign in." },
              { status: 401 }
            )
          }
        },
      },
    },
  })
)
